import React from "react";
import { useForm } from "react-hook-form";
import axios from "axios";

import { Circles } from "react-loader-spinner";
import { useNavigate } from "react-router-dom";

const BookNow = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  let navigate = useNavigate();

  const [successMessage, setSuccessMessage] = React.useState();
  const [bookingSuccess, setBookingSucess] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const onSubmit = async (data) => {
    data = {
      ...data,
      phone: Number(data.phone),
    };
    try {
      setBookingSucess(false);
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API_KEY}/api/book`,
        data
      );
      setSuccessMessage(response.data.data);

      setBookingSucess(true);
      setLoading(false);
    } catch (e) {
      setBookingSucess(false);
      setLoading(false);
      console.log(e);
    }
  };

  const modalMessage = () => {
    return (
      <div className="modal__container">
        <div className="modal__wrapper">
          <h5>Hello, {successMessage.fullName}</h5>
          <p style={{ fontSize: "12px", fontWeight: "400" }}>
            You have succesfully booked your seat! We will contact you shortly.
            Thank you.
          </p>
        </div>
      </div>
    );
  };

  React.useEffect(() => {
    setTimeout(() => {
      setBookingSucess(false);
    }, 5000);
  }, [bookingSuccess]);

  return (
    <div className="container">
      <div className="wrapper">
        <p className="header">BOOK YOUR SEAT NOW</p>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="form__container">
            {bookingSuccess && modalMessage()}
            <Circles
              height="80"
              width="80"
              color="#B3BDF1"
              ariaLabel="circles-loading"
              wrapperStyle={{ position: "absolute", left: "38%", top: "20%" }}
              wrapperClass=""
              visible={loading ? true : false}
            />
            <p>Full Name</p>
            <input
              type="text"
              name="fullName"
              id={errors.firstName && "error"}
              {...register("fullName", { required: true })}
            />
            {errors.fullName && (
              <p style={{ fontSize: "12px", color: "red" }}>
                Full Name is required!
              </p>
            )}
            <p>Phone</p>
            <input
              type="tel"
              name="phone"
              id={errors.phone && "error"}
              {...register("phone", {
                required: true,
                pattern: /^[0-9]*$/,
              })}
            />
            {errors.phone && (
              <p style={{ fontSize: "12px", color: "red" }}>
                Please enter valid phone number!
              </p>
            )}
            <p>Email</p>
            <input
              type="email"
              name="email"
              id={errors.email && "error"}
              {...register("email", {
                required: true,
                pattern:
                  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
              })}
            />
            {errors.email && (
              <p style={{ fontSize: "12px", color: "red" }}>
                Please enter valid email!
              </p>
            )}
            <p>Education</p>
            <input
              type="text"
              name="education"
              id={errors.education && "error"}
              {...register("education", { required: true })}
            />
            {errors.education && (
              <p style={{ fontSize: "12px", color: "red" }}>
                Please enter your current education level!
              </p>
            )}
            <div className="vertical-center">
              <button type="submit" className="submit-button">
                BOOK NOW!
              </button>

              <p
                style={{
                  fontSize: "14px",
                  borderTop: "2px solid blue",
                  paddingTop: "5px",
                }}
              >
                Already booked? Pay the training fee using Khalti.
              </p>
              <button
                onClick={() => navigate("/payment")}
                className="submit-button"
                type="button"
              >
                PAY NOW
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BookNow;
